export default __webpack_public_path__ + "static/media/styleguide-cards-bg1.1f7cdd47.png";